import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ToastConfig {
  id: string;
  text: string;
  delay: number;
  ongoing: boolean;
  color: 'default'|'danger'|'primary';
}

export interface ToastRef {
  hide: () => void;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  readonly toasts$ = new BehaviorSubject<ToastConfig[]>([]);

  show(text: string, config: Partial<ToastConfig> = {}): ToastRef {
    const id = config.id || `${Math.floor(Math.random() * 1000000)}`;

    if(!this.toasts$.value.find(t => t.id === id)) {
      this.toasts$.value.push({
        id,
        delay: 5000,
        ongoing: false,
        color: 'default',
        text,
        ...config,
      });
      this.toasts$.next(this.toasts$.value);
    }

    return {hide: () => this.hide(id)};
  }

  hide(id: string) {
    const toasts = this.toasts$.value.filter(t => t.id !== id);
    this.toasts$.next(toasts);
  }

  getToasts() {
    return this.toasts$.asObservable();
  }
}
